export enum ScheduleType {
  ONCE = 0,
  INTERVAL = 1,
  CRON = 2,
}

export enum ScheduleSource {
  ADMIN = 0,
  AGENT = 1,
}

export interface CronableParam {
  name: string;
  label: string;
  type: string; // string | integer | number | boolean | json
  required: boolean;
  default: unknown;
  description: string;
}

export interface CronableTask {
  key: string;
  name: string;
  description: string;
  queue: string;
  params: CronableParam[];
  admin_selectable: boolean;
  inject_user_id: boolean;
}

export interface ScheduledTask {
  id: number;
  name: string;
  task_key: string;
  task_name: string;
  user_id: number | null;
  user_label: string | null;
  user_email: string | null;
  kwargs: Record<string, unknown>;
  schedule_type: number;
  run_at: string | null;
  interval_seconds: number | null;
  cron_expression: string | null;
  enabled: boolean;
  next_run_at: string | null;
  last_run_at: string | null;
  last_status: string | null;
  last_error: string | null;
  run_count: number;
  source: number;
  agent_id: number | null;
  agent_name: string | null;
  conversation_id: number | null;
  created_at: string;
  updated_at: string;
  can_manage?: boolean;
}

export interface ScheduledTaskPayload {
  name?: string;
  task_key?: string;
  user_id?: number | null;
  kwargs?: Record<string, unknown>;
  schedule_type?: number;
  run_at?: string | null;
  interval_seconds?: number | null;
  cron_expression?: string | null;
  enabled?: boolean;
}
